import React, {useContext, useMemo} from 'react';
import {PlayerContext} from "../../../shared/contexts/playerContext";
import dayjs from "dayjs";
import LogTemplate from "../../logs/LogTemplate";
import {getErrorLogColumns} from "../../logs/columns/errorLogColumns";

const PlayerErrorLog = () => {
    const {playerData} = useContext(PlayerContext);
    const defaultSearchParams = {
        begin: dayjs().subtract(3, 'month').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        logType: 'error_log',
        userKey: playerData.userKey,
        isUnix: false
    };

    const columns = useMemo(() => getErrorLogColumns(false), []);

    return (
        <LogTemplate
            columns={columns}
            defaultSearchParams={defaultSearchParams}
            routerUrl={'/logs/error'}
            logName={'ErrorLog'}
            searchParamVisible={false}
        />
    );
};

export default PlayerErrorLog;